import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const useCountDown = targetTime => {
  const [remainingTime, setRemainingTime] = useState(undefined);

  useEffect(() => {
    const calculateRemainingTime = () => {
      if (targetTime) {
        setRemainingTime(targetTime.diff(dayjs(), 'seconds'));
      }
    };

    if (targetTime.diff(dayjs(), 'seconds') >= 0) {
      const intervalId = setInterval(calculateRemainingTime, 1000); //1초마다 불러오기
      return () => clearInterval(intervalId);
    }
  }, [targetTime, remainingTime]);

  return {
    remainingTime,
  };
};

export default useCountDown;
